/**
 * Suma N días a una fecha (string YYYY-MM-DD o Date)
 */
export function sumarDias(fecha, dias) {
  const f = new Date(fecha);
  f.setDate(f.getDate() + dias);
  return f;
}

/**
 * Suma N días y devuelve YYYY-MM-DD (ideal para inputs date)
 */
export function sumarDiasFormato(fecha, dias) {
  const f = sumarDias(fecha, dias);
  return f.toISOString().slice(0, 10);
}

export function fechaHoyAR() {
  const [dia, mes, anio] = new Intl.DateTimeFormat("es-AR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .format(new Date())
    .split("/");

  return `${anio}-${mes}-${dia}`; // ISO
}

export function formatHora(value) {
  // Devuelve hh:mm
  if (!value) return "";

  const texto = String(value).trim();

  // PostgreSQL TIME: "10:00:00" o "10:00"
  const match = texto.match(/^(\d{1,2}):(\d{2})/);

  if (match) {
    const hh = String(match[1]).padStart(2, "0");
    const mm = match[2];

    return `${hh}:${mm}`;
  }

  return "";
}

export function formatFecha(value) {
  //Devuelve dd-mm-yyyy
  if (!value) return "";

  const d = new Date(value);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}
